// extracted by mini-css-extract-plugin
module.exports = {"disableFormEdit":"SurveyForm_disableFormEdit__3HFF7"};